import { StageBadge } from "@/components/ui/stage-badge";
import { useDealStages } from "@/entities/settings/deal/hooks";
import { useSearchHighlight } from "@/contexts/SearchHighlightContext";
import { find } from "lodash";

interface Props {
  value: string;
}

const Stage: React.FC<Props> = ({ value }) => {
  const stages = useDealStages().data?.stages;
  const { searchQuery } = useSearchHighlight();
  const currentStage = find(stages, (stage) => stage.id === Number(value));
  return <StageBadge stage={currentStage} highlight={searchQuery} />;
};

export default Stage;
